/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Report_Line_CopilotInputs */



/**
* | output |
* | --- |
* | "Compliance Copilot ({plan})" |
*
* @param {Report_Line_CopilotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_line_copilot = /** @type {((inputs: Report_Line_CopilotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Line_CopilotInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Compliance Copilot (${i?.plan})`)
	return /** @type {LocalizedString} */ (`Compliance Copilot (${i?.plan})`)
});